module.exports = __webpack_public_path__ + "static/img/minimum-price.720af4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/minimum-price.png
// module id = SRwd
// module chunks = 1